import { useAuth } from "@/context/AuthContext";

export function roleHome(role) {
  if (role === "org_admin") return "/admin/dashboard";
  if (role === "enterprise_admin") return "/enterprise/dashboard";
  if (role === "supplier") return "/seller/dashboard";
  if (role === "technical_reviewer") return "/technical-reviewer/dashboard";
  if (role === "approver") return "/approver/dashboard";
  return "/buyer/dashboard";
}

export function useRoleBase() {
  const { user } = useAuth();
  if (user?.role === "org_admin") return "/admin";
  if (user?.role === "enterprise_admin") return "/enterprise";
  if (user?.role === "supplier") return "/supplier";
  if (user?.role === "technical_reviewer") return "/technical-reviewer";
  if (user?.role === "approver") return "/approver";
  return "/buyer";
}
